module.exports = __webpack_public_path__ + "static/img/wisdom.64393e58.png";